  <template>
    <div>
      <div class="d-flex" id="wrapper">
        <!-- Sidebar -->
        <SideBar/>
        <!-- /#sidebar-wrapper -->
        <!-- Page Content -->
        <div id="page-content-wrapper">
          <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
            <div>
              <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
              </button>

              <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
              </button>
            </div>
            <div class="d-flex">
              <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
              <p class="text-primary mb-0 hover-cursor">&nbsp;Resolution Center</p>
            </div>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ admin }}
                  </a>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 grid-margin stretch-card card-div">
                <div class="container">
                  <h5 class="card-title mb-4">Resolution Center </h5>
                  <div class="search-table container-fluid">
                    <div class="row">
                        <div class="col-lg-3 col-sm mobile-div">
                            Ticket Number
                            <input type="text" name="" class="form-control" placeholder="Ticket Number" v-model="searchTicketNo">
                        </div>
                        <div class="col-lg-3 col-sm mobile-div">
                            Company Name
                            <multiselect v-model="searchCompanyName" :options="companySelect" label="companyName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="All" track-by="companyName"></multiselect>
                        </div>
                        <div class="col-lg-3 col-sm mobile-div">
                            Product Code
                            <input type="text" name="" class="form-control" placeholder="Product Code" v-model="searchProductCode">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-sm mobile-div">
                            Status
                            <multiselect v-model="searchStatus" :options="statusSelect" label="statusName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="statusName" :multiple="true" :taggable="true" :close-on-select="false" group-values="libs" group-label="statusAll" :group-select="true"></multiselect>
                        </div>
                        <div class="col-lg-3 col-sm mobile-div">
                            Lessee PIC
                            <input type="text" name="" class="form-control" placeholder="PIC Name" v-model="searchPicName">
                        </div>
                        <div class="col-lg-3 col-sm mobile-div">
                            Technical PIC
                            <input type="text" name="" class="form-control" placeholder="Technician Name" v-model="searchTechnicianName">
                        </div>
                        <div class="col-lg-2 col-sm mobile-div">
                            <button class="btn btn-primary mt-4" @click="searchData"> Search </button>
                        </div>
                    </div>
                  </div>
                  <button class="btn btn-primary btn-sm mb-1" @click="openModal('Create')"> Create </button>
                  <table class="table table-sm table-bordered table-striped table-responsive-sm">
                    <thead class="">
                      <tr>
                        <th>No Tiket</th>
                        <th>Company Name</th>
                        <th>Product</th>
                        <th>Product Code</th>
                        <th>Status</th>
                        <th>Submit Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loadingTable === false && totalData == 0">
                        <td colspan="7" class="text-center">Data Not Available</td>
                      </tr>
                      <tr v-else-if="loadingTable === true">
                        <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                      </tr>
                      <tr v-for="(data, index) in dataComplain" :key="`complain-${index}`" v-else-if="loadingTable === false && totalData != 0">
                        <td>{{ data.codeTicket }}</td>
                        <td>{{ data.companyName }}</td>
                        <td>{{ data.productTypeName }}</td>
                        <td>{{ data.productCode }}</td>
                        <td>
                            <label v-if="data.status == 0" class="badge badge-reso-pending">Pending</label>
                            <label v-if="data.status == 1" class="badge badge-reso-confirmed">Confirmed</label>
                            <label v-if="data.status == 2" class="badge badge-reso-scheduled">Scheduled</label>
                            <label v-if="data.status == 3" class="badge badge-reso-repaired">Repaired</label>
                            <label v-if="data.status == 4" class="badge badge-reso-solved">Solved</label>
                            
                            <label v-if="data.status == 99" class="badge badge-reso-canceled" style="background-color: #121212;color: #ffffff;">Canceled</label>
                        </td>
                        <td>{{ data.submitDate }}</td>
                        <td><button class="btn btn-primary btn-sm" @click="toDetail(data.noTicket)"> Detail </button></td>
                      </tr>
                    </tbody>
                  </table>
                  <div id="wrapperr">
                    <div id="c1">
                      <div class="alignLeft total-data">
                        Total Data {{ totalData }} 
                      </div>
                    </div>
                    <div id="c2">
                      <div class="pagination p8 alignRight">
                        <ul>
                          <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                          <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                          <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                        </ul>
                      </div>
                    </div>
                  </div>​
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /#page-content-wrapper -->
        <div class="modal fade" id="modalCreate" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-header">
                <div class="change-title">
                  <h4 class="modal-title">Buat Tiket</h4>
                  <div v-if="endOfCase">
                    Masukkan detail permasalah lebih lanjut
                  </div>
                  <div v-else-if="caseKnowledgeShow && !isSolution && !endOfCase">
                    Pilih bagian produk yang bermasalah
                  </div>
                  <div v-else-if="caseKnowledgeShow && isSolution && !endOfCase">
                    Silakan coba solusi ini
                  </div>
                  <div v-else>
                    Masukkan data perusahaan dan tipe produk
                  </div>
                </div>
                <button type="button" class="close" @click="closeModal('Create')" data-dismiss="modal">&times;</button>
              </div>
              <div class="modal-body" v-if="!caseKnowledgeShow">
                <div class="mb-3">
                  <div class="text-title-field" :class="{ 'error-text': fieldCompanyError }">Company Name</div>
                  <!-- <div class="field"> -->
                    <multiselect v-model="companyChoose" :options="lesseeCompany" label="companyName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Company Name" @input="getCode" :class="{'error-field' : fieldCompanyError}"></multiselect>
                    <div class="error-text-message" v-if="fieldCompanyError">Company required fields</div>
                  <!-- </div> -->
                </div>
                <div class="mb-3">
                  <div class="text-title-field" :class="{ 'error-text': fieldCodeError }">Product Code / SN</div>
                    <multiselect v-model="codeChoose" :options="productCode" label="code" track-by="code" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Product Code / SN" :searchable="true" @input="getIdCode" :class="{'error-field' : fieldCodeError}"></multiselect>
                    <div class="error-text-message" v-if="fieldCodeError">Product code / SN required fields</div>
                </div>
                <!-- <div > -->
                  <div class="border border-warning w-100 mb-3 text-center p-2 align-middle d-flex" style="min-height: 55px;" v-if="activeTicket && codeChoose != ''">
                    <div style="margin: auto; padding: 3px;"> {{ codeChoose.activeTicket }} had <span class="ticket-code" @click="toDetail(codeChoose.ticketId)">{{ codeChoose.ticketCode }}</span> active, please check. </div> 
                  </div>
                <!-- </div> -->
                <div class="mb-3" v-if="countOrderCode == 2">
                  <div class="text-title-field" :class="{ 'error-text': fieldTypeSameError }">Product Type</div>
                  <!-- <div class="titik2">:</div> -->
                  <!-- <div class="field"> -->
                    <multiselect v-model="typeChoose" :options="typeSelect" label="productTypeName" track-by="productTypeName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Product Type" :searchable="true" :class="{'error-field' : fieldTypeSameError}" @input="validateSelf('productType')"></multiselect>
                    <div class="error-text-message" v-if="fieldTypeSameError">Product type required fields</div>
                  <!-- </div> -->
                </div>
                <div class="form-group" :class="{ 'form-group--error': $v.picName.$error }">
                    <label class="form__label">Client PIC Name</label>
                    <input class="form__input" v-model.trim="$v.picName.$model" placeholder="Client PIC Name"/>
                </div>
                <div class="error" v-if="!$v.picName.required">Client PIC name required fields</div>
                
                <div class="form-group" :class="{ 'form-group--error': $v.picPhone.$error }">
                    <label class="form__label">Client PIC Phone</label>
                    <div class="d-flex">
                        <input class="form__input" v-model.trim="$v.picPhone.$model" @keypress="isNumber($event)" placeholder="Client PIC Phone" @input="toPhoneFormat(picPhone)"/>
                    </div>
                </div>
                <div class="error" v-if="!$v.picPhone.required">Client PIC phone required fields</div>
                <div class="error" v-if="!$v.picPhone.phoneFormat">Wrong format, please use 62 or 08 or 02</div>
                <div>
                  <div class="text-title-field">Product Type</div>
                  <div class="">
                    <input type="text" name="note" class="form-control" v-model="typeCreate.productTypeName" disabled>
                  </div>
                </div>
              </div>
              <div class="modal-body" v-else-if="caseKnowledgeShow && !isSolution && !endOfCase">
                <label>Choose the current condition</label>
                <div v-if="!loadingCase">
                  <div v-if="caseKnowledge.length >= 10">
                    <div
                      v-for="(pair, index) in caseKnowledgePairs"
                      :key="index"
                      class="row justify-content-md-center"
                    >
                      <!-- Kolom Kiri -->
                      <div
                        class="col-5 mr-2 case-knowledge border border-secondary rounded w-100 mb-2 p-2"
                        @click="getCaseKnowledge(pair.left.id, pair.left.solution, pair.left.deviceStatus, pair.left.idBefore, 'next', pair.left.isManual)"
                      >
                        <i class="fas fa-power-off" v-if="pair.left.text == 'Power & Charger'"></i>
                        <i class="fas fa-desktop" v-if="pair.left.text == 'Layar'"></i>
                        <i class="fas fa-globe" v-if="pair.left.text == 'Internet'"></i>
                        <i class="fas fa-keyboard" v-if="pair.left.text == 'Keyboard'"></i>
                        <i class="fas fa-tablet" v-if="pair.left.text == 'Trackpad'"></i>
                        <i class="fab fa-usb" v-if="pair.left.text == 'USB Port'"></i>
                        <i class="fa fa-microphone" v-if="pair.left.text == 'Speaker & Microphone'"></i>
                        <i class="fas fa-camera" v-if="pair.left.text == 'Kamera'"></i>
                        <i class="fa fa-tachometer-alt" v-if="pair.left.text == 'Performance'"></i>
                        <i class="fas fa-microchip" v-if="pair.left.text == 'Software'"></i>
                        <i class="fas fa-plus" v-if="pair.left.text == 'Lainnya'"></i>
                        {{ pair.left.text }}
                      </div>

                      <!-- Kolom Kanan (hanya jika ada pasangannya) -->
                      <div
                        v-if="pair.right"
                        class="col-5 case-knowledge border border-secondary rounded w-100 mb-2 p-2"
                        @click="getCaseKnowledge(pair.right.id, pair.right.solution, pair.right.deviceStatus, pair.right.idBefore, 'next', pair.right.isManual)"
                      >
                        <i class="fab fa-usb" v-if="pair.right.text == 'USB Port'"></i>
                        <i class="fa fa-microphone" v-if="pair.right.text == 'Speaker & Microphone'"></i>
                        <i class="fas fa-camera" v-if="pair.right.text == 'Kamera'"></i>
                        <i class="fa fa-tachometer-alt" v-if="pair.right.text == 'Performance'"></i>
                        <i class="fas fa-microchip" v-if="pair.right.text == 'Software'"></i>
                        <i class="fas fa-plus" v-if="pair.right.text == 'Lainnya'"></i>
                        {{ pair.right.text }}
                      </div>

                      <!-- Placeholder agar layout tidak geser jika kolom kanan kosong -->
                      <div v-else class="col-5"></div>
                    </div>
                  </div>

                  <!-- Jika item < 10, tampilkan list biasa -->
                  <div v-else>
                    <div
                      v-for="(data, index) in caseKnowledge"
                      :key="data.text"
                      class="case-knowledge border border-secondary rounded w-100 mb-2 text-center p-2"
                      @click="getCaseKnowledge(data.id, data.solution, data.deviceStatus, data.idBefore, 'next', data.isManual)"
                    >
                      {{ data.text }}
                    </div>
                  </div>
                </div>
                <div v-if="loadingCase">
                  <div class="border border-secondary rounded w-100 mb-2 text-center p-2"> 
                      <img src="~@/assets/images/load-button.gif">
                  </div>
                </div>
              </div>
              <div class="modal-body" v-else-if="caseKnowledgeShow && isSolution && !endOfCase">
                <div v-if="!loadingCase">
                  <div v-for="(data, index) in caseKnowledge" :key="`case-${index}`" >
                      <div class="border border-secondary rounded w-100 mb-2 text-center p-2"> 
                        {{ data.text }}</div>
                  </div>
                </div>
                <div v-if="loadingCase">
                  <div class="border border-secondary rounded w-100 mb-2 text-center p-2"> 
                      <img src="~@/assets/images/load-button.gif">
                  </div>
                </div>
              </div>
              <div class="modal-body" v-else-if ="endOfCase">
                <div class="mb-3" v-if="caseInfo != '' || caseInfo != null"> {{ caseInfo }} </div>
                <div class="mb-3">
                  <div class="text-title-field w-100" :class="{ 'error-text': fieldProblemError }">Info detail mengenai permasalahan device</div>
                  <div><textarea rows="5" style="resize: none;" v-model="problem" class="w-100 rounded problem" :class="{ 'error-field-text': fieldProblemError }" @input="validateSelf('problem')"></textarea></div>
                  <div class="error-text-message" v-if="fieldProblemError">Field wajib diisi !</div>
                </div>
                <div class="mb-3">
                  <div class="text-title-field">Catatan</div>
                  <div><textarea rows="3" style="resize: none;" v-model="note" class="w-100 rounded"></textarea></div>
                </div>
                <div class="mb-3">
                  <div class="text-title-field w-100" :class="{ 'error-text': fieldClientAddressError }">Alamat Client</div>
                  <div><textarea rows="5" style="resize: none;" v-model="clientAddress" class="w-100 rounded problem" :class="{ 'error-field-text': fieldClientAddressError }" @input="validateSelf('clientAddress')"></textarea></div>
                  <div class="error-text-message" v-if="fieldClientAddressError">Field wajib diisi !</div>
                </div>
                <div class="mb-3">
                  <div class="text-title-field">Attachment 1</div>
                  <div class="d-flex">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="attachment_1" @change="onFilePicked($event,0)">
                      <label class="custom-file-label" for="customFile">{{attachment[0].fileName}}</label>
                    </div>
                    <button class="btn btn-danger ml-2" v-if="attachment[0].fileBase64 != ''" @click="deleteAttachment(0)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="text-title-field">Attachment 2</div>
                  <div class="d-flex">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="attachment_2" @change="onFilePicked($event,1)">
                      <label class="custom-file-label" for="customFile">{{attachment[1].fileName}}</label>
                    </div>
                    <button class="btn btn-danger ml-2" v-if="attachment[1].fileBase64 != ''" @click="deleteAttachment(1)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="text-title-field">Attachment 3</div>
                  <div class="d-flex">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="attachment_3" @change="onFilePicked($event,2)">
                      <label class="custom-file-label" for="customFile">{{attachment[2].fileName}}</label>
                    </div>
                    <button class="btn btn-danger ml-2" v-if="attachment[2].fileBase64 != ''" @click="deleteAttachment(2)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-outline-dark btn-sm" @click="closeModal('Create')" v-if="!caseKnowledgeShow || endOfCase">Batalkan</button>
                <button type="button" style="color: #409cff" class="btn btn-light btn-sm float-left" v-else-if="caseKnowledgeShow && !loadingButtonBack && !endOfCase" @click="getCaseKnowledge(null,'',null,'','back')">{{`< Sebelumnya`}}</button>
                <button type="button" style="color: #409cff" class="btn btn-light btn-sm" v-else-if="caseKnowledgeShow && loadingButtonBack" disabled><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Sebelumnya</button>

                <button type="button" style="color: #409cff" class="btn btn-light btn-sm" v-if="!loadingButtonStill && caseKnowledgeShow && isSolution" @click="getCaseKnowledge(caseKnowledge[0].id,caseKnowledge[0].solution,caseKnowledge[0].deviceStatus,caseKnowledge[0].idBefore,'still')">Masih bermasalah</button>
                <button type="button" style="color: #409cff" class="btn btn-light btn-sm" v-if="loadingButtonStill && caseKnowledgeShow && isSolution" disabled><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Masih bermasalah</button>

                <button type="button" class="btn btn-primary btn-sm" v-if="!loadingButtonSolved && caseKnowledgeShow && isSolution && !endOfCase" @click="submitAddComplain('solved')">Terselesaikan</button>
                <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonSolved && caseKnowledgeShow && isSolution && !endOfCase" disabled><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Terselesaikan</button>

                <button type="button" class="btn btn-primary btn-sm" v-if="!loadingButtonNext && !caseKnowledgeShow" @click="getCaseKnowledge(null,'',null,null,'next')" :disabled="activeTicket">Selanjutnya</button>
                <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonNext && !caseKnowledgeShow"><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Selanjutnya</button>

                <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false && caseKnowledgeShow && !isSolution && endOfCase" @click="submitAddComplain('etc')">Buat tiket</button>
                <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonProcess == true && caseKnowledgeShow && !isSolution && endOfCase"><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Buat tiket</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { required, minLength } from 'vuelidate/lib/validators'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import SideBar from '../SideBar'
  export default {
    name: 'ResolutionCenterPage',
    components:{
      SideBar,
      Multiselect
    },
    data () {
      return {
        spaceRegex : /[\u00A0\uFEFF\u202F]/g,
        admin:"",
        permission:[],
        viewDashboard: false,
        viewOrder: false,
        viewReturn: false,
        viewProduct: false,
        viewPairing: false,
        viewReconcile: false,
        viewResolution: false,
        viewLessor: false,
        viewLessee: false,
        viewEmployee: false,
        editOrder: false,
        editReturn: false,
        editProduct: false,
        editPairing: false,
        editReconcile: false,
        editResolution: false,
        editLessor: false,
        editLessee: false,
        editEmployee: false,
        dataComplain: [],
        totalPage:0,
        totalData:0,
        currentPage:1,
        orderId:"",
        companyName:"",
        statusOrder:"",
        loadingTable: true,
        loadingButtonProcess:false,
        loadingCase:false,
        loadingButtonStill:false,
        loadingButtonSolved:false,
        loadingButtonBack:false,
        loadingButtonNext:false,
        searchStatus:[],
        searchCompanyName:[
        {
            companyId:'',
            companyName:'All'
        }],
        searchTechnicianName:'',
        searchPicName:'',
        statusSelect:[{
          statusAll:'All',
          libs:[{
              status:'0',
              statusName:'Pending'
            },{
              status:'1',
              statusName:'Confirmed'
            },{
              status:'2',
              statusName:'Scheduled'
            },{
              status:'3',
              statusName:'Repaired'
            },{
              status:'4',
              statusName:'Solved'
            },
            {
              status:'99',
              statusName:'Canceled'
            }]
        }],
        codeChoose:'',
        productCode:[],
        companyChoose:'',
        lesseeCompany:[],
        problem:'',
        picName:'',
        picPhone:'',
        note:'',
        countOrderCode:0,
        typeChoose:'',
        typeSelect:[],
        typeCreate:{
          productTypeName:'',
          productType:''
        },
        caseKnowledge:[],
        caseKnowledgeShow:false,
        idBefore:[],
        isSolution:false,
        endOfCase:false,
        caseInfo:'',
        fieldCompanyError:false,
        fieldCodeError:false,
        fieldTypeSameError:false,
        fieldProblemError:false,
        fieldClientAddressError:false,
        errorMessage:'',
        activeTicket:false,
        caseChoose:null,
        attachment:[
          {
            fileName:'Choose file...',
            fileBase64:''
          },
          {
            fileName:'Choose file...',
            fileBase64:''
          },
          {
            fileName:'Choose file...',
            fileBase64:''
          }
        ],
        caseIdProblem:null,
        deviceStatus:null,
        searchTicketNo:null,
        searchProductCode:null,
        companySelect:[],
        clientAddress : '',
      }
    },
    computed: {
      caseKnowledgePairs() {
        let items = this.caseKnowledge
        const half = Math.ceil(items.length / 2)
        const isEven = items.length % 2 == 0
        const pairs = []
        // for (let i = 0; i < half; i++) {
        for (let i = 0; i < half; i++) {
          pairs.push({
            left: items[i],
            right: items[i + half] || null  // null jika tidak ada pasangan
          })
        }

        if(this.idBefore.length == 1 && this.idBefore[0] == null) {
          if(isEven) {
            pairs.push({
              left : {id: 0, text: "Lainnya", solution: 0, deviceStatus: null, idBefore: null, info: null, isManual: true},
              right: null
            })
          } else {
            pairs[half-1].right = {id: 0, text: "Lainnya", solution: 0, deviceStatus: null, idBefore: null, info: null, isManual : true}
          }
        }
        
        return pairs
      }
    },
    validations: {
          picName: {
              required
          },
          picPhone: {
              required,
              phoneFormat(phoneNumber) {
                  return (
                      phoneNumber.toString().substring(0, 3) == '628' ||
                      phoneNumber.toString().substring(0, 2) == '08' ||
                      phoneNumber.toString().substring(0, 2) == '02'
                  )
              },
          },
          validationNext: ['picName', 'picPhone'],
      },
    methods: {
      toPhoneFormat(phoneNumber){
        if (phoneNumber.length == 2 && phoneNumber == '08') {
          this.picPhone = '628'
        }
      },
      deleteAttachment(index){
          this.attachment[index].fileName = 'Choose file...'
          this.attachment[index].fileBase64 = ''
      },
      onFilePicked(e, index) {
          const files = e.target.files
          if (files[0] !== undefined) {
              var imgFileName = files[0].name
              var imgFile = files[0]
              if (imgFileName.lastIndexOf('.') <= 0) {
                  return
              }
              const fr = new FileReader()
              fr.readAsDataURL(files[0])
              fr.addEventListener('load', () => {
                  var imgBase64 = fr.result.split("base64,")[1]
                  if (imgFileName.toLowerCase().includes(".png") || imgFileName.toLowerCase().includes(".jpg") || imgFileName.toLowerCase().includes(".jpeg")) {
                      if (imgFile.size >= 5000000) {
                          imgFileName = ''
                          imgFile = ''
                          swal("Maximum size is 5MB", "", "warning", {
                              buttons: {
                                  agree: "OK",
                              },
                          })
                      }else{
                          this.attachment[index].fileName = imgFileName.replace(this.spaceRegex, ' ')
                          this.attachment[index].fileBase64 = imgBase64
                      }
                  } else {
                      swal("Photo only allows file types of PNG/JPG/JPEG.", "", "warning", {
                          buttons: {
                              agree: "OK",
                          },
                      })
                  }
              })
          } else {
              this.attachment[index].fileName = 'Choose file...'
              this.attachment[index].fileBase64 = ''
          }
      },
      validateSelf(fieldName){
        if (fieldName == 'productType') {
          this.fieldTypeSameError = false
        }else if (fieldName == 'problem'){
          if (this.problem.length == 0) {
            this.fieldProblemError = true
          }else{
            this.fieldProblemError = false
          }
        } else if(this.fieldName == 'clientAddress') {
          this.fieldClientAddressError = true
        }
      },
      resetCreateTicket(){
        this.caseKnowledgeShow = false
        this.companyChoose = ''
        this.codeChoose = ''
        this.productCode = []
        this.typeChoose = ''
        this.picName = ''
        this.picPhone = ''
        this.typeCreate = {
          productTypeName:'',
          productType:''
        }
        this.problem=''
        this.note=''
        this.fieldProblemError=false
        this.fieldClientAddressError=false
        this.caseChoose=null
        this.caseIdProblem=null
        this.clientAddress= ''
        this.attachment=[
          {
            fileName:'Choose file...',
            fileBase64:''
          },
          {
            fileName:'Choose file...',
            fileBase64:''
          },
          {
            fileName:'Choose file...',
            fileBase64:''
          }
        ]
        this.$v.validationNext.$reset()
        this.deviceStatus = null
      },
      closeModal(name){
        this.idBefore = [];
        $("#modal"+name).modal('hide')
      },
      getCaseKnowledge(id,solution,deviceStatus,idBefore,action,isManual){
        if(isManual) {
          console.log(isManual)
          this.deviceStatus = deviceStatus
          this.endOfCase = true
          this.caseChoose = id
        } else {
          if (this.cekField('next') == 0) {
            let api = true
            if (action == 'back' && this.idBefore.length == 1 && this.idBefore[0] == null) {
              id = this.idBefore[this.idBefore.length-1]
              this.idBefore.pop()
              api = false
              this.caseKnowledgeShow = false
            }else if (action == 'back' && this.idBefore.length > 1) {
              id = this.idBefore[this.idBefore.length-1]
              this.idBefore.pop()
            }else{
              this.idBefore.push(idBefore)
            }
            if (api) {
              this.loadingCase = true
              if (action == 'next') {
                this.loadingButtonNext = true
              }else if (action == 'still') {
                this.loadingButtonStill = true
              }else if (action == 'solved') {
                this.loadingButtonSolved = true
              }else if (action == 'back') {
                this.loadingButtonBack = true
              }
              // this.loadingButtonProcess = true
              this.$http.post(process.env.GET_CASE_KNOWLEDGE,{
                  productType: this.codeChoose.productType,
                  id: id
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                  this.caseKnowledge = [
                    ...response.data.content[0].caseKnowledge,
                  ]

                  const isFirstCall = this.idBefore.length == 1 && this.idBefore[0] == null
                  if (isFirstCall && this.caseKnowledge.length < 10) {
                    this.caseKnowledge.push({
                      id: 0,
                      text: 'Lainnya',
                      solution: 0,
                      deviceStatus: null,
                      idBefore: null,
                      info: null,
                      isManual: true
                    })
                  }
                  
                  this.loadingButtonNext= false
                  this.loadingButtonStill= false
                  this.loadingButtonSolved= false
                  // this.loadingButtonProcess= false
                  this.caseKnowledgeShow = true
                  this.loadingButtonBack = false
                  this.loadingButtonNext = false
                  this.loadingCase = false
                  this.isSolution = false
                  this.endOfCase = false
                  
                  if (this.caseKnowledge.length == 1 && this.caseKnowledge[0].solution == 1){
                    if (this.caseIdProblem == null) {
                        this.caseIdProblem = id
                    }
                    this.caseChoose = this.caseKnowledge[0].id
                    this.isSolution = true
                    this.caseInfo = this.caseKnowledge[0].info
                    this.deviceStatus = this.caseKnowledge[0].deviceStatus
                  } else if (this.caseKnowledge.length == 0) {
                    this.deviceStatus = deviceStatus
                    this.endOfCase = true
                    this.caseChoose = id
                  }

                  if (action == 'back' && this.caseKnowledge[0].solution == 0) {
                    this.caseIdProblem = null
                    this.caseChoose = null
                  }

                  if (action == 'back' && this.idBefore.length == 1 && this.idBefore[0] == null){
                    this.caseKnowledgeShow = false
                    this.deviceStatus = null
                  }
              })
              .catch(error => {
                console.log(error)
              })
            }
          }
        } 
        
      },
      isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
              evt.preventDefault();
            } else {
              return true;
            }
      },
      getIdCode(){
        this.activeTicket = false
        if (this.codeChoose.ticketCode != null) {
          this.activeTicket = true
        }
        this.fieldCodeError = false
        this.typeCreate = {
          productTypeName : this.codeChoose.productTypeName,
          productType : this.codeChoose.productType
        }
        this.countOrderCode = this.codeChoose.qty
          this.$http.post(process.env.GET_ID_PRODUCT_CODE,{
            companyId: this.companyChoose.companyId,
            orderCode: this.codeChoose.code
          },{
            headers: {'Asani-Token':localStorage.getItem('jwt')}
          })
          .then(response => {
            this.typeSelect = response.data.content
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      getCode(){
          this.fieldCompanyError = false
          this.picName = this.companyChoose.picName
          this.picPhone = this.companyChoose.picPhone
          this.codeChoose = ''
          this.$http.post(process.env.GET_PRODUCT_CODE,{
            companyId: this.companyChoose.companyId
          },{
            headers: {'Asani-Token':localStorage.getItem('jwt')}
          })
          .then(response => {
            this.productCode = response.data.content
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      cekField: function(buttonName){
        var error = 0
        this.fieldCompanyError = false
        this.fieldCodeError = false
        this.fieldTypeSameError = false
        this.fieldPicNameError = false
        this.fieldPicPhoneError = false
        this.$v.validationNext.$touch()

        if (buttonName == 'etc' && this.problem == '') {
            error = error+1
            this.fieldProblemError = true
        } else if(buttonName == 'etc' && this.clientAddress == '') {
          error = error+1
          this.fieldClientAddressError= true
        } else{
            if (this.companyChoose == '') {
              error = error+1
              this.fieldCompanyError = true
            }
            if (this.codeChoose == '') {
              error = error+1
              this.fieldCodeError = true
            }
            if (this.countOrderCode == '2' && this.typeChoose == '') {
              error = error+1
              this.fieldTypeSameError = true
            }
            if (this.$v.validationNext.$invalid) {
              error = error+1           
            }
        }
        return error
      },
      submitAddComplain(caseResult){
        const self = this
        if (this.cekField(caseResult) == 0) {
          let odId = ''
          if (this.countOrderCode == 1) {
            odId= this.codeChoose.odId
          }else{
            odId = this.typeChoose.id
          }
    
          this.loadingButtonProcess = true
          this.loadingButtonSolved = true
          this.$http.post(process.env.ADD_COMPLAIN,{
            companyId: this.companyChoose.companyId,
            productCode: this.codeChoose.code,
            problem: this.problem,
            picName: this.picName !== null ? this.picName.replace(this.spaceRegex, ' ') : this.picName,
            picPhone: this.picPhone,
            picAddress : this.clientAddress,
            note: this.note !== null ? this.note.replace(this.spaceRegex, ' ') : this.note,
            odId: odId,
            countOrderCode: this.countOrderCode,
            caseId: this.caseChoose,
            caseResult: caseResult,
            attachment: this.attachment,
            caseIdProblem: this.caseIdProblem,
            deviceStatus: this.deviceStatus,
            productType: this.codeChoose.productType
          },{
            headers: {'Asani-Token':localStorage.getItem('jwt')},
            timeout: 90 * 1000,
          })
          .then(response => {
            if (response.data.status === 200) {
              swal("Success", response.data.message, "success", {
                    button: "Ok",
              })
              this.idBefore = []
              this.loadingButtonProcess = false
            }
            if (response.data.status === 201) {
              swal("Sorry", response.data.message, "error", {
                    button: "Close",
              })
              this.idBefore = []
              this.loadingButtonProcess = false
            }
            this.companyChoose=''
            this.codeChoose=''
            this.typeChoose=''
            this.problem=''
            this.picName=''
            this.picPhone=''
            this.note=''
            this.getData()
            this.loadingButtonProcess = false
            this.loadingButtonSolved = false
            $("#modalCreate").modal('hide')
          })
          .catch(error => {
            self.loadingButtonProcess = false
            self.loadingButtonSolved = false
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
        }
      },
      openModal(x) {
        $("#modal"+x).modal('show')
        this.resetCreateTicket()
      },
      searchData(){      
        this.$router.push({path:'/resolution', query: {
              ticketNumber: this.searchTicketNo,
              companyId: this.searchCompanyName.companyId,
              companyName: this.searchCompanyName.companyName,
              productCode: this.searchProductCode,
              picName: this.searchPicName,
              technicianName: this.searchTechnicianName,
              statusComplain: JSON.stringify(this.searchStatus),
              page:1
          }
        })
        this.getData()
      },
      toDataPage(pagePost){
        this.loadingTable = true
        this.$router.push({path:'/resolution', query: {
              ticketNumber: this.searchTicketNo,
              companyId: this.searchCompanyName.companyId,
              companyName: this.searchCompanyName.companyName,
              productCode: this.searchProductCode,
              picName: this.searchPicName,
              technicianName: this.searchTechnicianName,
              statusComplain: JSON.stringify(this.searchStatus),
              page:pagePost
          }
        })
        this.getData()
      },
      toPage(e) {
        this.$router.push(e)
      },
      async handleLogout() {
        try {
          const response = await this.$http.post(process.env.LOGOUT, {}, {
            headers: {
              'Asani-Token': localStorage.getItem('jwt')
            }
          })
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            return
          }

        } catch (error) {
          if(error.response.data.status != 401) {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            })
            return
          }
        }
        localStorage.removeItem('jwt')
        localStorage.removeItem('admin_name')
        localStorage.removeItem('roles')
        localStorage.removeItem('user_email')
        localStorage.removeItem('admin_id')
        localStorage.removeItem('changeCatalogPermission')
        this.$router.push('/')
      },
      cekLogin(){
        if (localStorage.getItem('jwt') == null) {
          this.$router.push('/')
        }
      },
      cekPermission(){
        this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
        for(var i=0; i < this.permission.length; i++){
          if( this.permission[i] == "1"){
            this.viewDashboard = true
          }
          if( this.permission[i] == "2.1"){
            this.viewOrder = true
          }
          if( this.permission[i] == "2.2"){
            this.editOrder = true
          }
          if( this.permission[i] == '3.1'){
            this.viewReturn = true
          }
          if( this.permission[i] == '3.2'){
            this.editReturn = true
          }
          if( this.permission[i] == '4.1'){
            this.viewProduct = true
          }
          if( this.permission[i] == '4.2'){
            this.editProduct = true
          }
          if( this.permission[i] == '5.1'){
            this.viewPairing = true
          }
          if( this.permission[i] == '5.2'){
            this.editPairing = true
          }
          if( this.permission[i] == '6'){
            this.viewReconcile = true
          }
          if( this.permission[i] == '7.1'){
            this.viewResolution = true
          }
          if( this.permission[i] == '7.2'){
            this.editResolution = true
          }
          if( this.permission[i] == '8.1'){
            this.viewLessor = true
          }
          if( this.permission[i] == '8.2'){
            this.editLessor = true
          }
          if( this.permission[i] == '9.1'){
            this.viewLessee = true
          }
          if( this.permission[i] == '9.2'){
            this.editLessee = true
          }
          if( this.permission[i] == '10'){
            this.viewEmployee = true
          }
        }
        if (this.viewResolution == false) {
          this.$router.push('/')
        }
      },
      sidebar(){
        $("#wrapper").toggleClass("toggled");
      },
      toDetail(id){
        window.open(this.$router.resolve('/resolution/detail/' + id).href, '_blank');
      },
      getData(){
        this.searchTicketNo = this.$route.query.ticketNumber
        this.searchCompanyName = {
          companyId : this.$route.query.companyId,
          companyName: this.$route.query.companyName
        }
        this.searchProductCode = this.$route.query.productCode
        this.searchPicName = this.$route.query.picName
        this.searchTechnicianName = this.$route.query.technicianName
        this.searchStatus = []
        this.searchStatus = JSON.parse(this.$route.query.statusComplain)
        this.currentPage = parseInt(this.$route.query.page)
        let status = []
        for (var i = 0; i < this.searchStatus.length; i++) {
          status.push(this.searchStatus[i].status)
        }
        this.loadingTable = true
        this.$http.post(process.env.SEARCH_COMPLAIN,{
          companyId: this.searchCompanyName.companyId,
          ticketNumber: this.searchTicketNo !== null ? this.searchTicketNo.replace(this.spaceRegex, ' ') : this.searchTicketNo,
          productCode: this.searchProductCode !== null ? this.searchProductCode.replace(this.spaceRegex, ' ') : this.searchProductCode,
          picName: this.searchPicName !== null ? this.searchPicName.replace(this.spaceRegex, ' ') : this.searchPicName,
          technicianName: this.searchTechnicianName !== null ? this.searchTechnicianName.replace(this.spaceRegex, ' ') : this.searchTechnicianName,
          status: status,
          page: this.$route.query.page
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          this.dataComplain = response.data.content.data
          this.companySelect = response.data.content.company
          this.totalPage = response.data.content.totalPage
          this.totalData = response.data.content.totalData
          this.currentPage = response.data.content.currentPage
          this.loadingTable = false

        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })

        this.$http.get(process.env.GET_LESSEE_COMPANY,{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
          }else{
              this.lesseeCompany = response.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      },
      sendLog(x){
          var today = new Date();
          var month = today.getMonth()+1
          if (month < 10) {
              month = '0'+month
          }
          var dateDay = today.getDate()
          if (dateDay < 10) {
              dateDay = '0'+dateDay
          }
          var hours = today.getHours()
          if (hours < 10) {
              hours = '0'+hours
          }
          var minutes = today.getMinutes()
          if (minutes < 10) {
              minutes = '0'+minutes
          }
          var second = today.getSeconds()
          if (second < 10) {
              second = '0'+second
          }
          var date = today.getFullYear()+'-'+month+'-'+dateDay;
          var time = hours + ":" + minutes + ":" + second;
          var dateTime = date+' '+time;
          var admin = this.admin
          var command = 'add-logs'
          var productName = this.productNameChoose
          this.$http.post(process.env.LOG_URL+"/ticket/"+x,{
              codeLogs: 36,
              params: [],
          },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
          })
          .then(response => {
          })
          .catch(error => {
              console.log(error)
          })
      }
    },
    created(){
      this.getData()
      this.admin = localStorage.getItem('admin_name')
      this.cekLogin()
      this.cekPermission()
    }
  }
  $(document).ready(function(){
    var self = this
  $('#modalCreate').on('hidden.bs.modal', function () {
      // self.wadaw()
  });
  });
  </script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    .case-knowledge:hover{
      cursor: pointer;
      background-color: #2797FB;
      color: white;
    }
  .key{
    width: 168px;
    margin: 7px 0px;
  }
  .titik2{
    margin: 7px 0px;
    padding: 0px 9px;
  }
  .field{
    width: 100%;
  }
  .one-line{
    display: flex;
    margin: 4px 0px;
  }
  .pagination{
  padding: 0px 0;
  }

  .pagination ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
  }

  .pagination a{
  display: inline-block;
  padding: 1px 6px;
  color: #222;
  }

  .p8 a{
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
  }

  .p8 a:hover{
  text-decoration: none;
  }
  .p8 a.page:hover{
  text-decoration: none;
  color: #fff;
  }

  .p8 .is-active{
  background-color: #fff;
  color: #2797FB;
  }

  .alignleft {
  float: left;
  }
  .alignright {
  float: right;
  }

  .pagg{
  display: inline-flex;
  overflow:auto;
  }

  .total-data{
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
  }
  #wrapperr{
    overflow:auto;
    margin: 5px 3px;
  }

  #c1{
  float:left;
  }

  #c2{
  float: right;  
  }

  .search-table{
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
  }
  .active{
  color: #2797FB;
  }
  .right-dropdown{
  margin-left: 7px;
  }
  .account-div{
  margin: 2px 2px;
  }
  .right-arrow{
  margin-left: auto;
  }
  .brand-logo{
  width: 120px;
  }
  .menu-title{
  margin-left: 1.125rem;
  }
  .menu-title-order{
  margin-left: 1.95rem;
  }
  .menu-title-payment{
  margin-left: 1.525rem;
  }

  ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
  }

  li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
  }

  li a.active {
  background-color: #4CAF50;
  color: white;
  }

  li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
  }
  .nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
  }
  .nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
  }
  .nav-side-menu .toggle-btn {
  display: none;
  }
  .nav-side-menu ul,
  .nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
  }
  .nav-side-menu ul :not(collapsed) .arrow:before,
  .nav-side-menu li :not(collapsed) .arrow:before {
    font-family: FontAwesome;
    content: "\f078";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu ul .active,
  .nav-side-menu li .active {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
  }
  .nav-side-menu ul .sub-menu li.active,
  .nav-side-menu li .sub-menu li.active {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li.active a,
  .nav-side-menu li .sub-menu li.active a {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li,
  .nav-side-menu li .sub-menu li {
    background-color: #181c20;
    border: none;
    line-height: 28px;
    border-bottom: 1px solid #23282e;
    margin-left: 0px;
  }
  .nav-side-menu ul .sub-menu li:hover,
  .nav-side-menu li .sub-menu li:hover {
    background-color: #020203;
  }
  .nav-side-menu ul .sub-menu li:before,
  .nav-side-menu li .sub-menu li:before {
    font-family: FontAwesome;
    content: "\f105";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu li {
    padding-left: 0px;
    border-left: 3px solid #2e353d;
    border-bottom: 1px solid #23282e;
  }
  .nav-side-menu li a {
    text-decoration: none;
    color: #e1ffff;
  }
  .nav-side-menu li a i {
    padding-left: 10px;
    width: 20px;
    padding-right: 20px;
  }
  .nav-side-menu li:hover {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
  }
  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
  @media (max-width: 573px){
    .mobile-div{
      padding: 2px 0px;
    }
  }
  </style>



// WEBPACK FOOTER //
// src/components/Resolution/ResolutionCenterPage.vue